import { Session } from 'data/session';
import { controllerApi } from './api';
import { env } from 'env/env';

const getLoginUrl = () => {
    if (env.appRedirectLogin) {
        return `${controllerApi}/auth/login?redirect_uri=${encodeURI(env.appRedirectLogin)}`;
    }

    return `${controllerApi}/auth/login`;
}

export const refresh = async (): Promise<Session | undefined> => {
    return fetch(`${controllerApi}/auth/refresh`, {
        method: "POST",
        credentials: "include",
    }).then((res: Response) => {
        if (res.type === "opaqueredirect" || res.status !== 200) {
            window.location.href = getLoginUrl();
            return
        }
        return res.json();
    }).then(res => {
        if (!res) {
            return undefined
        }

        return res.data
    }).catch(() => {
        window.location.href = getLoginUrl();
    });
}

export const disconnect = async (): Promise<null> => {
    return fetch(`${controllerApi}/auth/logout`, {
        method: "POST",
        redirect: "manual",
        credentials: "include",
    }).then((res: Response) => {
        window.location.href = getLoginUrl();
        return res.json();
    });
}
